export const LIGHT_THEME_BACKGROUND = '#ffffff'
export const LIGHT_THEME_TEXT = '#101011'
export const DARK_THEME_BACKGROUND = '#101011'
export const DARK_THEME_TEXT = '#ffffff'

export function isLightTheme(siteSettings = {}) {
  if (typeof window === 'undefined') return false

  const params = new URLSearchParams(window.location.search)
  const theme = params.get('theme') || params.get('palette')
  const normalizedTheme = String(theme).toLowerCase()

  if (['light', 'white', 'inverted'].includes(normalizedTheme)) return true
  if (['dark', 'black', 'default'].includes(normalizedTheme)) return false

  return !!siteSettings.use_light_theme
}

export function getThemeColor(siteSettings = {}) {
  return isLightTheme(siteSettings) ? LIGHT_THEME_TEXT : DARK_THEME_TEXT
}

export function getThemeBackground(siteSettings = {}) {
  return isLightTheme(siteSettings) ? LIGHT_THEME_BACKGROUND : DARK_THEME_BACKGROUND
}

export function shouldUseSiteBackgroundImage(siteSettings, value) {
  return !isLightTheme(siteSettings) && !!value
}
